import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {TableRow} from "../../../core/components/table/table-row";
import {TableCell} from "../../../core/components/table/table-cell";
import {ScoreboardWidgetStageViewModel} from "../models/scoreboard-widget.stage-view-model";

export class ScoreboardWidgetRowProps extends BaseProps {
  stages: Array<ScoreboardWidgetStageViewModel>;
}

export const ScoreboardWidgetMatchTimeTableRow = (props: ScoreboardWidgetRowProps) => {
  return (
    <TableRow className={'scoreboard-widget-match-time-row'}>
      <TableCell className={'scoreboard-widget-match-time-cell'}/>
      {
        props.stages.map((stage: ScoreboardWidgetStageViewModel) => {
          const className = ['scoreboard-widget-match-time-cell', (stage.isLive ? 'scoreboard-widget-match-time-cell-live' : '')].join(' ');

          return <TableCell className={className} key={stage.id}>{stage.time}</TableCell>
        })
      }
    </TableRow>
  )
}
